module.exports = "<!--Page Header-->\n<div class=\"header\">\n  <div class=\"header-content\">\n    <div class=\"page-title\"><i class=\"icon-display4\"></i> {{titulo}}</div>\n    <breadcrumbs-nav></breadcrumbs-nav>\n  </div>\n</div>\n<!--/Page Header-->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/painel/page-header.component.html
// module id = ./src/app/painel/page-header.component.html
// module chunks = main